import useGetCount from '@/pages/explore/useGetCount';

// Offers
import starredOffers from '@/pages/offers-filtered/starred/useQuery';
import newOffers from '@/pages/offers-filtered/new/useQuery';
import draftOffers from '@/pages/offers-filtered/draft/useQuery.last4weeks';
import activeOffers from '@/pages/offers-filtered/active/useQuery';
import nearbyOffers from '@/pages/offers-filtered/nearby/useQuery';
import schoolYearOffers from '@/pages/offers-filtered/school-year/useQuery';

export default function getNavigationLinks() {
  return [
    { name: 'All', href: `/offers` },
    // { name: 'All (Table)', href: `/offers` },
    { name: 'Nearby', href: `/offers/nearby`, count: useGetCount(nearbyOffers) },
    { name: 'Starred', href: `/offers/starred`, count: useGetCount(starredOffers) },
    { name: 'New', href: `/offers/new`, count: useGetCount(newOffers), highlight: true },
    { name: 'Incomplete', href: `/offers/draft`, count: useGetCount(draftOffers) },
    { name: 'Active Offers', href: `/offers/active`, count: useGetCount(activeOffers) },
    { name: 'All Offers this School Year', href: `/offers/school-year`, count: useGetCount(schoolYearOffers) }
  ];
}
